import { Component, HostListener, OnInit, ɵConsole } from '@angular/core';
import { AuthService } from 'app/security/auth.service';
import { NotificationService } from 'app/services/notification-service';
import { PolicyService } from 'app/services/policy-service';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';
import { CommonsUtils } from 'app/commons/CommonsUtils';
import { ClientService } from 'app/services/client-service';

@Component({
  selector: 'app-header-navigation-bar',
  templateUrl: './header-navigation-bar.component.html',
  styleUrls: ['./header-navigation-bar.component.scss']
})
export class HeaderNavigationBarComponent implements OnInit {

  burgerState: Boolean = false;
  showChangeEntity: Boolean = false;
  showDirectAreas: Boolean = true;
  // La cabecera se muestra siempre en su estado "scrolleado" (barra blanca), sin depender
  // del scroll: nav-white, la barra de entidad, el aux-box y el burger azul quedan fijos.
  scrolled: Boolean = true;

  /** Respaldo mientras no han llegado los datos de cliente: el nombre del token. */
  tokenFullName: string = '';
  private client: any = null;
  userMenuOpen: boolean = false;

  /**
   * Se compone de los datos de cliente y no del token: asi incluye el primer apellido y se
   * refresca solo al editar el perfil, porque this.client es el mismo objeto que ClientService
   * actualiza al guardar.
   */
  get userFullName(): string {
      return CommonsUtils.fullName(this.client) || this.tokenFullName;
  }

  toggleUserMenu(event: Event): void {
      event.stopPropagation();
      // En movil ambos menus conviven en la barra, asi que se cierra el otro: de lo contrario
      // el panel de navegacion quedaria abierto por debajo del desplegable de usuario.
      this.burgerState = false;
      this.userMenuOpen = !this.userMenuOpen;
  }

  closeUserMenu(): void {
      this.userMenuOpen = false;
  }

  @HostListener('document:click') onDocumentClick(): void {
      this.userMenuOpen = false;
  }

  toggle: Boolean = true;

  loadingNotifications: Boolean = false;
  notifications: any;

  loadingPolicyNotifications: Boolean = false;
  policyNotifications: any;

  loadingEventNotifications: Boolean = false;
  eventNotifications: any;

  pendingNotifications: boolean;
  pendingEventNotifications: boolean;
  pendingPolicyNotifications: boolean;

  readingNotifications: boolean;

  // "Mis beneficios" solo para tomadores de PP09/PP11/DJ13/DJ29 (ver PolicyService).
  showBenefits: Boolean = false;

  // "Mis asegurados" solo aplica a pólizas de Asistencia Jurídica Familiar (DJ29).
  hasLegalAssistanceProduct: Boolean = false;

  toggleBurger() {
      // El menu de usuario ya lo cierra el @HostListener de document:click, que se dispara al
      // propagarse este mismo clic; se deja explicito para no depender de ese efecto lateral.
      this.userMenuOpen = false;
      this.burgerState = !this.burgerState;
  }

  getBurgerClass(): String {
      let result = '';
      if (this.burgerState) {
          result += 'open ';
      }
      // Blanco solo cuando se recorta contra el fondo de la barra transparente. Con el menu
      // abierto va en azul: el aspa se dibuja sobre la barra blanca y antes se pintaba blanca
      // porque el panel tenia una cabecera oscura debajo, que ya no existe.
      if (!this.scrolled && !this.burgerState) {
          result += ' burger-white';
      } else {
          result += ' burger-blue';
      }
      return result;

  }

  constructor(
      private authService: AuthService,
      private notificationService: NotificationService,
      private policyService: PolicyService,
      private clientService: ClientService,
      private toastr: ToastrService) {
      }

  ngOnInit(): void {
      if ((this.authService.isLogged()) && (this.authService.getUser().entities.length > 1)) {
          this.showChangeEntity = true;
      }
      this.authService.getSelectedEntity() === 'ONLYGAL' ? this.showDirectAreas = true : this.showDirectAreas = false;

      const u = this.authService.getUser();
      if (u) {
          this.tokenFullName = `${u.name || ''} ${u.lastName || ''}`.trim();
      }

      // getClient() cachea en ClientService, asi que esto no supone una llamada extra si otra
      // pantalla ya la ha hecho. Si falla se sigue mostrando el nombre del token, sin avisar:
      // la cabecera no es el sitio para un error de carga de perfil.
      if (this.authService.isLogged()) {
          this.clientService.getClient()
              .then(client => { this.client = client; })
              .catch(() => { this.client = null; });
      }

      // Obtener notificaciones dado la configuración obtenida.

      this.loadingNotifications = true;
      this.notificationService.getNotifications()
          .then(success => {
              this.loadingNotifications = false;
              this.notifications = success.response;
          }).catch(error => {
              this.loadingNotifications = false;
              this.notifications = [];
              this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTI_RECI, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                  timeOut: 5000
              });
          });

      if (this.showDirectAreas) {
          this.policyService.hasBenefitProducts()
              .then(has => { this.showBenefits = has; });
      }

      this.loadLegalAssistanceProduct();
  }

  private loadLegalAssistanceProduct(): void {
      this.policyService.hasLegalAssistanceProduct()
          .then(has => { this.hasLegalAssistanceProduct = has; });
  }

  checkPendingNotifications() {
      this.pendingNotifications = false;

      if (this.notifications) {
          this.notifications.forEach(not => {
              if (not.isRead != 'S') {
                  this.pendingNotifications = true;
              }
          });
      }

      return this.pendingNotifications;
  }


  delete(notification) {
      let arrayIds: number[] = [notification.agenNotId];
      this.notificationService.markNotificationAsRead(arrayIds)
          .then(success => {
              let index = null;
              const found = this.notifications.find(n => n.agenNotId === notification.agenNotId);

              if (found) {
                  index = this.notifications.indexOf(found);
                  if (index > -1) {
                      this.notifications.splice(index, 1);
                  }

                  if (this.notifications.length == 0) {
                      this.pendingNotifications = false;
                  }
              }
          }).catch(error => {
              this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                  timeOut: 5000
              });
          });

  }


  markAsRead(notification) {
      if (notification && notification.isRead != 'S') {
          const found = this.notifications.find(n => n.agenNotId === notification.agenNotId);
          if (found) {
              const index = this.notifications.indexOf(found);
              found.isRead = 'S';
              this.notifications[index] = found;
              this.checkPendingNotifications();
          }

          let arrayIds: number[] = [notification.agenNotId];
          this.notificationService.markNotificationAsRead(arrayIds)
              .then(success => {

              }).catch(error => {
                  const found = this.notifications.find(n => n.agenNotId === notification.agenNotId);
                  if (found) {
                      const index = this.notifications.indexOf(found);
                      found.isRead = '';
                      this.notifications[index] = found;
                      this.checkPendingNotifications();
                  }
                  this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                      timeOut: 5000
                  });
              });
      }
  }

  readAll() {
      this.readingNotifications = true;
      let arrayIds: number[] = [];
      this.notifications.forEach(n => {
          arrayIds.push(n.agenNotId)
      });
      this.notificationService.markNotificationAsRead(arrayIds)
          .then(success => {
              this.readingNotifications = false;
              this.notifications.forEach(n => {
                  n.isRead = 'S'
              });
              this.pendingNotifications = false;
          }).catch(error => {
              this.readingNotifications = false;
              this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                  timeOut: 5000
              });
          });
  }


  deleteAll() {
      this.readingNotifications = true;
      let arrayIds: number[] = [];
      this.notifications.forEach(n => {
          arrayIds.push(n.agenNotId)
      });
      this.notificationService.markNotificationAsRead(arrayIds)
          .then(success => {
              this.notifications = [];
              this.pendingNotifications = false;
              this.readingNotifications = false;
          }).catch(error => {
              this.readingNotifications = false;
              this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                  timeOut: 5000
              });
          });
  }

  getEntityClassNav(){
      switch (localStorage.getItem('entity')) {
        case 'C0494':
            return 'bar-meridiano';
        case 'L0639':
            return 'bar-euroins';
        case 'L1454':
            return 'bar-prima';
        case 'C0616':
            return 'bar-seguro-rga';
          case 'C0012':
              return 'bar-eterna-aseguradora';
          case 'C0037':
              return 'bar-santander';
          case 'C0072':
              return 'bar-generali';
          case 'C0124':
              return 'bar-segurcaixa';
          case 'C0133':
              return 'bar-ocaso';
          case 'C0139':
              return 'bar-patria-hispana';
          case 'C0157':
              return 'bar-helvetia';
          case 'C0161':
              return 'bar-dkv';
          case 'C0572':
              return 'bar-lagun-aro';
          case 'C0786':
              return 'bar-mutua';
          case 'DLA03':
              return 'bar-aegon';
          case 'DLA04':
              return 'bar-ergo';
          case 'DLA06':
              return 'bar-amic';
          case 'DLA07':
              return 'bar-allianz';
          case 'DLA09':
              return 'bar-vidacaixa';
          case 'E0217':
              return 'bar-erv';
          case 'L0614':
              return 'bar-nationale-suisse';
          case 'L0639':
              return 'bar-euroins';
          case 'M0084':
              return 'bar-mmt';
          case 'M0199':
              return 'bar-mutua-propietarios';
          default:
              return '';
      }
  }

  getEntityClass(){
      switch (localStorage.getItem('entity')) {
        case 'C0494':
            return 'meridiano';
        case 'L0639':
            return 'euroins';
        case 'L1454':
            return 'prima';
        case 'C0616':
            return 'seguro-rga';
          case 'C0012':
              return 'eterna-aseguradora';
          case 'C0037':
              return 'santander';
          case 'C0072':
              return 'generali';
          case 'C0124':
              return 'segurcaixa';
          case 'C0133':
              return 'ocaso';
          case 'C0139':
              return 'patria-hispana';
          case 'C0157':
              return 'helvetia';
          case 'C0161':
              return 'dkv';
          case 'C0572':
              return 'lagun-aro';
          case 'C0786':
              return 'mutua';
          case 'DLA03':
              return 'aegon';
          case 'DLA04':
              return 'ergo';
          case 'DLA06':
              return 'amic';
          case 'DLA07':
              return 'allianz';
          case 'DLA09':
              return 'vidacaixa';
          case 'E0217':
              return 'erv';
          case 'L0614':
              return 'nationale-suisse';
          case 'L0639':
              return 'euroins';
          case 'M0084':
              return 'mmt';
          case 'M0199':
              return 'mutua-propietarios';
          default:
              return '';
      }
  }

}
